import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Wrapper from "../../../../../../components/wrappers/Wrapper";
import { CRIMSON_RED } from "../../../../../../enums/Colors";
import { capitalizeFirstLetter } from "../../../../../../utils/Functions";
import WorkingDayForm from "../form/WorkingDayForm";

export default function WorkingDaysDisplay({ workingDay }) {
  const [isAccordionExpanded, setIsAccordionExpanded] = React.useState(false);
  const { t } = useTranslation();
  const methods = useFormContext();

  const handleAccordionToggle = () => {
    setIsAccordionExpanded(!isAccordionExpanded);
  };

  const { errors } = methods.formState;

  function isEmpty(obj) {
    for (const prop in obj) {
      if (Object.hasOwn(obj, prop)) {
        return false;
      }
    }

    return true;
  }

  function setBorderError() {
    if (!isEmpty(errors)) {
      if (errors?.workingDays?.hasOwnProperty(workingDay?.day)) {
        return `2px solid ${CRIMSON_RED}`;
      }
    }
  }

  return (
    <Box mb={2} sx={{ border: setBorderError() }}>
      <Accordion
        expanded={isAccordionExpanded}
        onChange={() => handleAccordionToggle()}
      >
        <AccordionSummary>
          <Wrapper noPaper>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"center"}
              spacing={2}
            >
              <Controller
                name={`workingDays.${workingDay?.day}.workingDay`}
                control={methods.control}
                defaultValue={workingDay?.workingDay}
                render={({ field }) => (
                  <Switch
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    checked={field.value}
                    onChange={(e) => {
                      field.onChange(e.target.checked);
                    }}
                  />
                )}
              />
              <Typography>
                {t(capitalizeFirstLetter(String(workingDay?.day)))}
              </Typography>
            </Stack>
          </Wrapper>
        </AccordionSummary>
        <AccordionDetails>
          <WorkingDayForm workingDay={workingDay} />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
